//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      shopName:'asdfasdf',
      addGoodsState:false,
      manager:'',
      managerList:[{value:1,label:'系列1'}],
      addGoodsState:false,
      tableData:[],
      // 备注
      textarea:'',
      selectGoodsState:false,
      initShopArea:'全部',
      selectGoods:{},
      selectGoodsTableData:[],
      shopList:[],
      shop:'请选择店铺',
      shopMsg:{},
      pageSizes:[5, 10, 15, 20],
      pageSizeValue:5,
      total:0,
      pageNo:1,
      focusState:false,
    }
  },
  mounted(){
    this.shopList.push({dShopName:'请选择店铺',dShopId:'请选择店铺'})
    let data = {
      pageNo:1,
      pageSize:1,
      dealerId:window.sessionStorage.getItem('dealerId'),
    }
    this.shopList = []
    data.orderStatus = 1
    this.$axios.post('/mtea/stock/dealer/orderSearch', data).then(res => {
      this.shopList = res.shopList
    })
  },
  methods: {
    cellStyel(row){
      let style = {}
      if(row.column.label === '操作')
      style['text-align'] = 'right'
      return style
    },
    headerCellStyel(row){
      let style = {}
      if(row.column.label === '操作')
      style['text-align'] = 'right'
      style['background-color'] = '#f2f2f2'
      return style
    },
    addClick(){
      this.selectGoodsState = true
      this.infoGoodsList(true)
    },
    selectGoodsFun(row){
      console.log(row)
    },
    selectShop(row){
      this.shopList.forEach(e=>{
        if(e.dShopId === row)
        this.shopMsg = e
      })
    },
    infoGoodsList(state = false){
      if(state){
        this.pageNo = 1
      }
      // if(this.initShopBrand !== '全部')method.cid = this.initShopBrand
      // if(this.initShopArea !== '全部')method.bid = this.initShopArea
      let method = {
        dealerId:window.sessionStorage.getItem('dealerId'),
        pageNo:this.pageNo,
        pageSize:this.pageSizeValue,
      }
      if(this.selectGoods.goodsName !== "")
      method.goodsName = this.selectGoods.goodsName
      this.$axios.post('/mtea/stock/dealer/goodsSearch', method).then(res => {
        console.log(res)
        res.records.forEach(e=>{
          e.orderMoney = e.price/100
        })
        // this.tableData = res.records
        this.total = res.total
        this.selectGoodsTableData = res.records
      })
    },
    sizeChange(num){
      this.pageSizeValue = num
      this.infoGoodsList()
    },
    currentChange(num){
      this.pageNo = num
      this.infoGoodsList()
    },
    deleteGoods(row){
      let newArr = this.tableData.filter((e) => e.goodsId!==row.goodsId);
      this.tableData = newArr
    },
    // 计算价格
    subtotal(row){
      console.log(row)
      if(row.count !== '' & row.price !== ''){
        row.orderMoney = row.count * row.price
      }
    },
    // 选择商品
    selectGoodsClickFun(row){
      let v = JSON.parse(JSON.stringify(row))
      v.price = v.price/100
      for (let i = 0; i < this.tableData.length; i++) {
        if(this.tableData[i].goodsId === v.goodsId){
          ++this.tableData[i].count
          this.tableData[i].orderMoney = this.tableData[i].count * this.tableData[i].price
          // this.tableData = JSON.parse(JSON.stringify(this.tableData))
          // this.subtotal()
          return
        }
      }
      v.count = 1
      this.tableData.push(v)
      console.log(this.tableData)
    },
    saveGoodsList(){
      if(this.shop === '请选择店铺'){
        this.$message('请选择店铺！');
        this.$refs.inputRef.focus()
        return
      }
      if(this.tableData.length === 0){
        this.$message('请选择订单中的商品！');
        return
      }
      console.log(this.tableData,this.shopMsg,JSON.stringify(this.shopMsg))
      // if(this.shop !== '请选择店铺'){
      //   return
      // }
      let data = JSON.parse(JSON.stringify(this.shopMsg))
      data.itemList = this.tableData
      data.address = data.dShopAddress
      data.userName = data.dShopLinkman
      data.userPhone = data.dShopPhone
      let method = {
        dealerId:window.sessionStorage.getItem('dealerId'),
        orderJson:JSON.stringify(data)
      }
      this.$axios.post('/mtea/stock/dealer/doAddOrder', method).then(() => {
        this.$message({
          message: '保存成功',
          type: 'success'
        });
        this.$router.push({name:'order'})
      })
    }
  },
}
